export default [
  {
    prop: 'mch_price',
    label: '商户号退款金额',
    minWidth: 120,
    tooltip: true
  },
  {
    prop: 'mch_id',
    label: '退款商户号',
    minWidth: 150,
    tooltip: true
  },
  {
    prop: 'service_price',
    label: '退款服务费',
    minWidth: 100,
    tooltip: true
  },
  {
    prop: 'rate',
    label: '服务费率',
    minWidth: 80,
    tooltip: true
  },
  {
    prop: 'withdrawal_price',
    label: '实际退款金额',
    minWidth: 120,
    tooltip: true
  },
  {
    prop: 'user',
    label: '收款人',
    minWidth: 100,
    tooltip: true
  },
  {
    prop: 'bank',
    label: '开户行',
    minWidth: 120,
    tooltip: true
  },
  {
    prop: 'bank_card',
    label: '银行卡号',
    minWidth: 140,
    tooltip: true
  },
  {
    prop: 'create_time',
    label: '申请时间',
    minWidth: 160,
    tooltip: true
  },
  {
    prop: 'withdrawal_time',
    label: '退款时间',
    minWidth: 160,
    tooltip: true
  },
  {
    prop: 'status',
    label: '状态',
    minWidth: '100px'
  },
  {
    prop: 'action',
    width: '120px',
    label: '操作'
  }
]
